import React from "react";
import "../../../AllComponentCSS.css";

function JS_filter() {
  return (
    <div className="tutorial-page">
      <h1>JS filter</h1>
      <p>This page will cover the filter topic in detail.</p>
    </div>
  );
}

export default JS_filter;
